/*
 * Created on Tue Dec 16 2019
 * Author: Val Liu
 * Copyright (c) 2019
 */

import { Config } from "@/../config/default/i18n";

var config: Config = {
    defaultLang: "zh-TW",
};
export default config;
